
define(
	'DC.PLPCustomization.FacetsItemCell'
,   [
		//'DC.PLPCustomization.FacetsItemCell.View'
		'Facets.ItemCell.View',
		'underscore'
	]
,   function (
		FacetsItemCellView,
		_
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			_.extend(FacetsItemCellView.prototype, {
				getContext: _.wrap(FacetsItemCellView.prototype.getContext, function(fn){
					var context = fn.apply(this, _.toArray(arguments).slice(1));
					context.storedescription = this.model.get('storedescription');
					
					console.log('storedescription: ', context.storedescription);
					
					return context;
				})
			});

		}
	};
});
